/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class KnownExploitedVulnerability {
    getFixupPrototypeFunction() { return KnownExploitedVulnerability.fixupPrototype; }

    static newInstance(model: Partial<KnownExploitedVulnerability>): KnownExploitedVulnerability {
        let obj = Object.assign(new KnownExploitedVulnerability(), model);
        KnownExploitedVulnerability.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<KnownExploitedVulnerability>): KnownExploitedVulnerability {
        if (!model) return null;
        return KnownExploitedVulnerability.newInstance(<KnownExploitedVulnerability> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: KnownExploitedVulnerability) {
        if (!obj) return;

        models.KnownExploitedVulnerability.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: KnownExploitedVulnerability): boolean {
        Object.setPrototypeOf(obj, KnownExploitedVulnerability.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.vulnerability_added_date === "string") {
            this.vulnerability_added_date = new Date(<string><any>this.vulnerability_added_date);
        }
        if (typeof this.vulnerability_due_date === "string") {
            this.vulnerability_due_date = new Date(<string><any>this.vulnerability_due_date);
        }
        if (typeof this.created_at === "string") {
            this.created_at = new Date(<string><any>this.created_at);
        }
        if (typeof this.updated_at === "string") {
            this.updated_at = new Date(<string><any>this.updated_at);
        }
    }

    /**
     * The CVE ID of the vulnerability in the format CVE-YYYY-NNNN, note that the number portion can have more than 4 digits
     */
    cve_id: string;

    /**
     * The vendor or project name for the vulnerability
     */
    vendor_project: string;

    /**
     * The product name for the vulnerability
     */
    product: string;

    /**
     * The name of the vulnerability
     */
    vulnerability_name: string;

    /**
     * The date the vulnerability was added to the catalog
     */
    vulnerability_added_date: Date;

    /**
     * A short description of the vulnerability
     */
    short_description: string;

    /**
     * The required action to address the vulnerability
     */
    required_action: string;

    /**
     * The date the required action is due
     */
    vulnerability_due_date: Date;

    /**
     * 'True' if this vulnerability is known to have been leveraged as part of a ransomware campaign; 'False' if CISA lacks confirmation that the vulnerability has been utilized for ransomware
     */
    is_known_ransomware_campaign: boolean;

    /**
     * Any additional notes about the vulnerability
     */
    notes: string;

    cwe_codes: Array<string>;

    /**
     * Vulnerability created time
     */
    created_at: Date;

    /**
     * Vulnerability updated time
     */
    updated_at: Date;

}
